import React from 'react';
import { usePageMeta } from '../lib/seo';
import { ButtonLink, Container, PageHero, Section } from '../components/SiteUi';

export default function NotFoundPage() {
  usePageMeta({
    title: 'Page not found – CloudNext',
    description: 'The page you were looking for could not be found.',
    path: '/404',
    robots: 'noindex, follow',
  });

  return (
    <>
      <PageHero
        eyebrow="404"
        title={<>That page is not <span className="text-gold-gradient">here.</span></>}
        description="The link may be old, or the page may have moved. These are the main places to go next."
        compact
      >
        <div className="flex flex-col gap-3 sm:flex-row">
          <ButtonLink to="/">Back to home</ButtonLink>
          <ButtonLink to="/ai-receptionist" variant="secondary">AI receptionist</ButtonLink>
          <ButtonLink to="/contact" variant="secondary">Contact</ButtonLink>
        </div>
      </PageHero>
      <Section>
        <Container>
          <div className="grid gap-3 text-sm text-dust sm:grid-cols-2 lg:grid-cols-4">
            <ButtonLink to="/pricing" variant="ghost" className="justify-start px-0">Pricing →</ButtonLink>
            <ButtonLink to="/demo" variant="ghost" className="justify-start px-0">Demo →</ButtonLink>
            <ButtonLink to="/custom-software" variant="ghost" className="justify-start px-0">Custom software →</ButtonLink>
            <ButtonLink to="/guides" variant="ghost" className="justify-start px-0">Guides →</ButtonLink>
          </div>
        </Container>
      </Section>
    </>
  );
}
